import { makeStyles } from '@material-ui/core';

const useChartsCardStyles = makeStyles(() => ({
  container: (spaceRight) => ({
    display: 'flex',
    paddingBottom: 25,
    paddingRight: spaceRight ? 25 : 0,
    borderRadius: 2,
    height: '100%',
  }),
  chartContainer: {
    background: '#fff',
    padding: 25,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  title: {
    fontFamily: 'Roboto',
    fontSize: 16,
    fontWeight: 500,
    fontStyle: 'normal',
    lineHeight: '20px',
    letterSpacing: 0.29,
    textAlign: 'left',
    color: '#49515a',
  },
  durationSelect: {
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: '20px',
    letterSpacing: 0.25,
    textAlign: 'left',
    color: '#60676f',
    '&:before,&:after': {
      border: 'none',
    },
    '&:hover:not(.Mui-disabled)': {
      '&:before,&:after': {
        border: 'none',
      },
    },
  },
  subtitle: {
    fontFamily: 'Roboto',
    fontSize: 14,
    fontWeight: 'normal',
    fontStyle: 'normal',
    lineHeight: '20px',
    letterSpacing: 0.25,
    textAlign: 'left',
    color: '#60676f',
    padding: '5px 0 25px',
  },
}));

export { useChartsCardStyles };
